module.exports = __webpack_public_path__ + "img/tick.634455b0.svg";